import { EventsQuery } from '../generated/graphql';
import isEmpty from 'lodash/isEmpty';

const toLocationString = (location?: EventsQuery['events'][0]['location']) =>
  [location?.city, location?.state, location?.country].filter(val => val).join(', ');

interface CeremonyAndReception {
  reception?: NonNullable<EventsQuery['events'][0]['subEvents']>[0];
  ceremony?: NonNullable<EventsQuery['events'][0]['subEvents']>[0];
}

export const getHpLocation = (events?: EventsQuery['events'], defaultLocation?: string | null) => {
  const weddingEvent: EventsQuery['events'][0] | undefined = (events || []).find(event => event.type === 'WeddingDay');
  if (weddingEvent) {
    const weddingEventLocation = toLocationString(weddingEvent?.location);
    if (!isEmpty(weddingEventLocation)) {
      return weddingEventLocation;
    }
    const { reception, ceremony } = (weddingEvent.subEvents || []).reduce(
      (memo: CeremonyAndReception, event) => {
        if (event.type === 'Reception') {
          memo.reception = event;
        }
        if (event.type === 'Ceremony') {
          memo.ceremony = event;
        }
        return memo;
      },
      { reception: undefined, ceremony: undefined }
    );
    let location = '';
    if (reception) {
      location = toLocationString(reception?.location);
    }
    if (isEmpty(location) && ceremony) {
      location = toLocationString(ceremony?.location);
    }
    if (!isEmpty(location)) {
      return location;
    }
  }
  return defaultLocation;
};
